<template>
  <v-flex xs12 class="mainContainer">
    <v-flex xs12 v-if="display !== 'selectOrganization'">
      <v-layout row style="display: flex; justify-content: center">
        <v-flex xs7 class="borderSplit" style="max-width: 450px;" v-if="display === 'login'">
          <v-flex xs12 style="font-size: 36px; font-weight: 300;margin-bottom: 30px;" class="primary--text">
            Login to Yakshof Market
          </v-flex>
          <v-form>
            <v-text-field autofocus single-line solo flat ref="email" placeholder="Email Address" v-model="email" :error-messages="emailErrorMsgs" required @blur="$v.email.$touch()" class="loginFormField" color="accent"></v-text-field>
            <v-text-field single-line solo flat ref="password" placeholder="Password" v-model="password" v-on:keyup.enter='submitLoginForm' type="password" :error-messages="passwordErrorMsgs" label="Password" required @blur="$v.password.$touch()" class="loginFormField" color="accent" style="margin-bottom: 0 !important"></v-text-field>
            <v-layout row>
              <v-spacer></v-spacer>
              <v-btn flat :ripple="false" style="height: 20px; padding-right: 0; font-size: 14px !important" @click="display = 'forgot'">Forgot password?</v-btn>
            </v-layout>
            <v-flex style="text-align: center">
              <v-btn large round @click="submitLoginForm" class="primary secondary--text submitLoginBtn" style="height: 45px; width: 160px; font-size: 18px" :loading="loadingState === 'loading'">Login</v-btn>
            </v-flex>
            <v-flex xs12 style="text-align: center; font-size: 14px">
              Don't have an account? Create one <span class="signUpBtn" @click="goToSignup" small flat :ripple="false" style="padding-left: 0; min-width: 30px; margin-left: 0; font-weight: 700; cursor: pointer">HERE</span>.
            </v-flex>
          </v-form>
        </v-flex>
        <v-flex xs7 class="borderSplit" style="max-width: 450px;" v-if="display === 'forgot'">
          <v-flex xs12 style="font-size: 36px; font-weight: 300;margin-bottom: 30px;" class="primary--text">
            Forgot password
          </v-flex>
          <v-form>
            <v-text-field autofocus single-line solo flat ref="forgotEmail" placeholder="Email Address" v-model="forgotEmail" :error-messages="forgotEmailErrorMsgs" @input="emailNotFound = false" required @blur="$v.forgotEmail.$touch()" class="forgotFormField" color="accent"></v-text-field>
            <v-text-field autofocus single-line solo flat ref="forgotEmailConfirmation" placeholder="Confirm Email Address" v-model="forgotEmailConfirmation" :error-messages="forgotEmailConfirmationErrorMsgs" required @blur="$v.forgotEmailConfirmation.$touch()" class="forgotFormField" color="accent" style="margin-bottom: 0 !important"></v-text-field>
            <v-layout row>
              <v-spacer></v-spacer>
              <v-btn flat style="height: 20px; padding-right: 0; font-size: 14px !important" @click="display = 'login'">Cancel</v-btn>
            </v-layout>
            <v-flex style="text-align: center">
              <v-btn large round @click="submitForgotForm" class="primary secondary--text submitForgotBtn" style="height: 45px; width: 160px; font-size: 18px" :loading="forgotLoadingState === 'loading'" :disabled="$v.forgotEmail.$invalid || $v.forgotEmailConfirmation.$invalid">Confirm</v-btn>
            </v-flex>
            <v-flex style="text-align: center;font-size: 14px !important;" class="error--text" v-if="emailNotFound">Email not found!</v-flex>
          </v-form>
        </v-flex>
        <v-flex xs7 class="borderSplit" style="max-width: 450px;" v-if="display === 'forgotSuccess'">
          <v-flex xs12 style="font-size: 36px; font-weight: 300;margin-bottom: 30px;" class="primary--text">
            Email Sent
          </v-flex>
          <img src="@/assets/check.png" style="max-height: 80px; margin-bottom: 20px">
          <v-flex xs12 style="font-size: 18px;font-weight: 500" class="primary--text">An email message has been sent to your address.</v-flex>
          <v-flex xs12 style="font-size: 18px;font-weight: 500" class="primary--text">Kindly follow its instructions to reset your password.</v-flex>
        </v-flex>
        <v-flex xs7 class="borderSplit" style="max-width: 450px;" v-if="display === 'reset'">
          <v-flex xs12 style="font-size: 36px; font-weight: 300;margin-bottom: 30px;" class="primary--text">
            Reset Password
          </v-flex>
          <v-form>
            <v-text-field autofocus single-line type="password" solo flat ref="resetPassword" placeholder="Password" v-model="resetPassword" :error-messages="resetPasswordErrorMsgs" required @blur="$v.resetPassword.$touch()" class="resetFormField" color="accent"></v-text-field>
            <v-text-field autofocus single-line type="password" solo flat ref="resetPasswordConfirmation" placeholder="Confirm Password" v-model="resetPasswordConfirmation" :error-messages="resetPasswordConfirmationErrorMsgs" required @blur="$v.resetPasswordConfirmation.$touch()" class="resetFormField" color="accent" style="margin-bottom: 0 !important"></v-text-field>
            <v-flex style="text-align: center; margin-top: 20px">
              <v-btn large round @click="submitResetForm" class="primary secondary--text submitResetBtn" style="height: 45px; width: 160px; font-size: 18px" :loading="resetLoadingState === 'loading'">Confirm</v-btn>
            </v-flex>
          </v-form>
        </v-flex>
        <v-flex xs7 class="borderSplit" style="max-width: 450px;" v-if="display === 'resetSuccess'">
          <v-flex xs12 style="font-size: 36px; font-weight: 300;margin-bottom: 30px;" class="primary--text">
            Success!
          </v-flex>
          <img src="@/assets/check.png" style="max-height: 80px; margin-bottom: 20px">
          <v-flex style="text-align: center">
            <v-btn large round @click="display = 'login'" class="primary secondary--text loginBtn" style="height: 45px; width: 160px; font-size: 18px">Login</v-btn>
          </v-flex>
        </v-flex>
        <v-flex xs5 style="padding-left: 5%;max-width:300px;">
          <v-flex xs12 style="font-size: 36px;margin-bottom: 30px;font-weight: 300" class="primary--text">Need help?</v-flex>
          <v-flex xs12 style="font-size: 18px;font-weight: 500;margin-bottom: 15px" class="primary--text">email@yakshof.com</v-flex>
          <v-flex xs12 style="font-size: 18px;font-weight: 500" class="primary--text">+961 1 123256</v-flex>
          <v-flex xs12 style="font-size: 18px;font-weight: 500" class="primary--text">+961 3 123256</v-flex>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12 v-else-if="display === 'selectOrganization'" style="display: flex; align-items: center; justify-content: center; flex-direction: column;">
      <v-flex style="font-size: 24px; font-weight: 700; margin-bottom: 60px;" class="primary--text">Select Organization</v-flex>
      <v-layout row>
        <v-flex v-if="currentUser && currentUser.organizations" v-for="item in currentUser.organizations" :key="item.id" style="text-align: center; min-width: 120px; display: flex; flex-direction: column; align-items: center; cursor: pointer" class="mx-4 primary--text" @click="getOrganizationData(item.id)">
          <div style="height: 100px; width: 100px; border-radius: 100%; font-size: 48px; font-weight: 300; border: 1px solid #011E41; display: flex; align-items: center; justify-content: center; margin-bottom: 10px">{{item.name[0]}}</div>
          <div style="font-size: 18px" class="primary--text">{{item.name}}</div>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-flex>
</template>

<style>
  .mainContainer{
    padding: 10% 5%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .loginFormField, .forgotFormField, .resetFormField{
    border-radius: 50px;
    max-width: 450px;
    height: 45px;
    border: 1px solid #011E41;
    margin-bottom: 20px !important
  }
  .loginFormField .v-input__slot, .forgotFormField .v-input__slot, .resetFormField .v-input__slot{
    background-color: transparent !important;
    border-radius: 50% !important;
    margin-bottom: 0 !important;
    padding-left: 20px !important;
    padding-top: 0 !important
  }
  .loginFormField .v-text-field__details, .forgotFormField .v-text-field__details, .resetFormField .v-text-field__details{
    padding-left: 22px !important
  }
  .borderSplit{
    border-right: 1px solid #C6CEEA;
    padding-right: 5%;
  }
  .submitLoginBtn .v-btn__content, .submitForgotBtn .v-btn__content, .submitResetBtn .v-btn__content, .signUpBtn .v-btn__content{
    font-size: 18px;
  }
</style>

<script>
import vh, { email, password, forgotEmail, forgotEmailConfirmation, resetPassword, resetPasswordConfirmation } from '@/helpers/validators'
import { mapMutations, mapGetters } from 'vuex'
import axios from 'axios'

export default {
  data () {
    return {
      display: 'login',
      email: '',
      password: '',
      loadingState: 'none',
      user: null,
      forgotEmail: '',
      forgotEmailConfirmation: '',
      forgotLoadingState: 'none',
      resetPassword: '',
      resetPasswordConfirmation: '',
      resetLoadingState: 'none',
      emailNotFound: false
    }
  },
  validations: {
    email: vh.vrules(email),
    password: vh.vrules(password),
    forgotEmail: vh.vrules(forgotEmail),
    forgotEmailConfirmation: vh.vrules(forgotEmailConfirmation),
    resetPassword: vh.vrules(resetPassword),
    resetPasswordConfirmation: vh.vrules(resetPasswordConfirmation)
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn', 'currentUser', 'currentToken']),
    ...mapGetters({getOrganizations: 'getOrganizations', getNewUserUuid: 'getNewUserUuid'}),
    emailErrorMsgs () {
      if (this.$v.email.$dirty) {
        return vh.vmsg(this.$v.email, email)
      } else {
        return []
      }
    },
    forgotEmailErrorMsgs () {
      if (this.$v.forgotEmail.$dirty) {
        return vh.vmsg(this.$v.forgotEmail, forgotEmail)
      } else {
        return []
      }
    },
    forgotEmailConfirmationErrorMsgs () {
      if (this.$v.forgotEmailConfirmation.$dirty) {
        return vh.vmsg(this.$v.forgotEmailConfirmation, forgotEmailConfirmation)
      } else {
        return []
      }
    },
    resetPasswordErrorMsgs () {
      if (this.$v.resetPassword.$dirty) {
        return vh.vmsg(this.$v.resetPassword, resetPassword)
      } else {
        return []
      }
    },
    resetPasswordConfirmationErrorMsgs () {
      if (this.$v.resetPasswordConfirmation.$dirty) {
        return vh.vmsg(this.$v.resetPasswordConfirmation, resetPasswordConfirmation)
      } else {
        return []
      }
    },
    passwordErrorMsgs () {
      if (this.$v.password.$dirty) {
        return vh.vmsg(this.$v.password, password)
      } else {
        return []
      }
    }
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    submitLoginForm () {
      if (this.$v.password.$invalid || this.$v.email.$invalid) {
        return
      }
      this.login()
    },
    submitForgotForm () {
      if (this.$v.forgotEmail.$invalid || this.$v.forgotEmailConfirmation.$invalid) {
        return
      }
      this.forgotLoadingState = 'loading'
      axios.all([this.$store.dispatch('userForgot', {email: this.forgotEmail.toLowerCase()})]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          this.emailNotFound = false
          this.display = 'forgotSuccess'
          this.forgotLoadingState = 'none'
        } else {
          this.notify({message: 'Something went wrong.', show: true})
          this.forgotLoadingState = 'none'
        }
      })).catch((err) => {
        this.forgotLoadingState = 'none'
        if (err.response.status === 401) {
          this.emailNotFound = true
        } else {
          this.notify({message: 'Something went wrong while connecting to the server.', show: true})
          console.log(err)
        }
      })
    },
    async login () {
      this.loadingState = 'loading'
      try {
        var data = { email: this.$data.email.toLowerCase(), password: this.$data.password }
        await this.$store.dispatch('auth/login', { ...data })
        if (this.currentUser.active) {
          let cookieUser = {
            uuid: this.currentUser.uuid,
            firstName: this.currentUser.firstName,
            lastName: this.currentUser.lastName,
            email: this.currentUser.email,
            active: this.currentUser.active,
            projects: []
          }
          for (var i = 0; i < this.currentUser.projects.length; i++) {
            cookieUser.projects.push({
              uuid: this.currentUser.projects[i].uuid,
              name: this.currentUser.projects[i].name,
              description: this.currentUser.projects[i].description,
              status: this.currentUser.projects[i].status})
          }
          this.$cookie.delete('ykx-v2-cookie-jwt-token', {domain: (process.env.NODE_ENV === 'production' ? '.dataslicer.io' : 'localhost')})
          this.$cookie.delete('ykx-v2-cookie-jwt-user', {domain: (process.env.NODE_ENV === 'production' ? '.dataslicer.io' : 'localhost')})
          this.$cookie.set('ykx-v2-cookie-jwt-token', this.currentToken, {expires: '1M', domain: (process.env.NODE_ENV === 'production' ? '.dataslicer.io' : 'localhost')})
          this.$cookie.set('ykx-v2-cookie-jwt-user', JSON.stringify(cookieUser), {expires: '1M', domain: (process.env.NODE_ENV === 'production' ? '.dataslicer.io' : 'localhost')})
          this.$data.dialog = false
          this.loadingState = 'none'
          if (this.currentUser && this.currentUser.organizations && this.currentUser.organizations.length === 1) {
            if (this.$route.query && this.$route.query.path && this.$route.query.path !== '/' && this.$route.query.path !== '/login') {
              this.getOrganizationData(this.currentUser.organizations[0].id)
            } else {
              this.$router.push('/market')
            }
          } else if (this.currentUser) {
            if (this.currentUser.organizations.length > 1) {
              this.display = 'selectOrganization'
            } else {
              this.getOrganizationData(this.currentUser.organizations[0].id)
            }
          }
        } else {
          this.$store.dispatch('auth/logout')
          this.notify({message: 'Please make sure you activate your account before login.', show: true})
          this.loadingState = 'none'
        }
      } catch (e) {
        console.log(e)
        this.notify({message: 'You have failed to log in. Try again with other credentials.', show: true})
        this.loadingState = 'none'
      }
    },
    getOrganizationData (id) {
      axios.all([this.$store.dispatch('getOrganizationsWithAllById', {id: id})]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          this.$store.commit('setUserOrganization', response.data.payload)
          if (this.$route.query && this.$route.query.path && this.$route.query.path !== '/signup' && this.$route.query.path !== '/login') {
            this.$router.push({path: this.$route.query.path, query: this.$route.query})
          } else {
            this.$router.push('/market')
          }
        } else {
          this.notify({message: 'Something went wrong.', show: true})
        }
      })).catch((err) => {
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    },
    getUserData () {
      axios.all([this.$store.dispatch('getUserByUuid', {uuid: this.getNewUserUuid})]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          this.user = response.data.payload
          this.display = 'reset'
        } else {
          this.notify({message: 'Something went wrong.', show: true})
        }
      })).catch((err) => {
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    },
    goToSignup () {
      if (this.$route.query && this.$route.query.path) {
        this.$router.push({path: '/signup', query: this.$route.query})
      } else {
        this.$router.push('/signup')
      }
    },
    submitResetForm () {
      this.resetLoadingState = 'loading'
      this.user.password = this.resetPassword
      axios.all([this.$store.dispatch('updateUser', this.user)]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          this.display = 'resetSuccess'
          this.resetLoadingState = 'none'
        } else {
          this.resetLoadingState = 'none'
          this.notify({message: 'Something went wrong.', show: true})
        }
      })).catch((err) => {
        this.resetLoadingState = 'none'
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    },
    mountLogin () {
      if (this.$route.query && this.$route.query.state) {
        if (this.$route.query.state === 'reset') {
          this.getUserData()
        } else if (this.$route.query.state === 'organization' && this.isLoggedIn) {
          if (this.currentUser && this.currentUser.organizations && this.currentUser.organizations.length === 1) {
            if (this.$route.query && this.$route.query.path && this.$route.query.path !== '/signup' && this.$route.query.path !== '/login') {
              this.$router.push({path: this.$route.query.path, query: this.$route.query})
            } else {
              this.$router.push('/market')
            }
          } else if (this.currentUser) {
            if (this.currentUser.organizations.length > 1) {
              this.display = 'selectOrganization'
            } else {
              this.getOrganizationData(this.currentUser.organizations[0].id)
            }
          }
        } else if (this.$route.query.state === 'login') {
          this.display = 'login'
        } else if (!this.isLoggedIn) {
          this.$router.push({path: '/login', query: this.$route.query})
        }
      } else {
        if (this.isLoggedIn) {
          this.$store.dispatch('auth/logout')
        }
      }
    }
  },
  mounted () {
    this.mountLogin()
  },
  watch: {
    '$route.query.state': function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.mountLogin()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue